if (!customElements.get('sticky-atc')) {
  customElements.define(
    'sticky-atc',
    class StickyAtc extends HTMLElement {
      connectedCallback() {
        const target = document.getElementById(this.dataset.targetId);
        const button = this.querySelector('button');
        if (!target || !button) return;

        this.observer = new IntersectionObserver(([entry]) => {
          const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          this.classList.toggle('sticky-atc--visible', scrolledPast);
        });
        this.observer.observe(target);

        const syncDisabled = () => (button.disabled = target.disabled);
        syncDisabled();
        this.mutationObserver = new MutationObserver(syncDisabled);
        this.mutationObserver.observe(target, { attributes: true, attributeFilter: ['disabled'] });
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.mutationObserver) this.mutationObserver.disconnect();
      }
    }
  );
}

// Clickable rating stars: smooth scroll to the reviews section, below the header when it stays visible
if (!window.productRatingStarsLinkBound) {
  window.productRatingStarsLinkBound = true;
  document.addEventListener('click', (event) => {
    const link = event.target.closest('.product-rating-stars--link');
    if (!link) return;

    const target = document.getElementById(link.dataset.scrollTarget);
    if (!target) return;

    event.preventDefault();
    const stickyHeader = document.querySelector(
      'sticky-header[data-sticky-type="always"], sticky-header[data-sticky-type="reduce-logo-size"]'
    );
    const offset = stickyHeader ? stickyHeader.offsetHeight : 0;
    window.scrollTo({ top: target.getBoundingClientRect().top + window.scrollY - offset, behavior: 'smooth' });
  });
}
